import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProtectedRoute from './components/ProtectedRoute';
import AuthRedirect from './components/AuthRedirect';
import { AUTH_ROUTES } from './config/routes';
import { UserRole } from './types/auth.types';

/**
 * Module principal d'authentification
 * Ce composant encapsule toute la logique d'authentification et fournit les routes nécessaires
 */
const AuthModule: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AuthProvider>
      {/* Redirection automatique après connexion */}
      <AuthRedirect 
        adminPath={AUTH_ROUTES.ADMIN}
        organizationPath={AUTH_ROUTES.ORGANIZATION}
        userProfilePath={AUTH_ROUTES.USER_PROFILE}
        defaultPath={AUTH_ROUTES.DEFAULT}
      />
      
      {/* Rendu des enfants (application principale) */}
      {children}
    </AuthProvider>
  );
};

/**
 * Composant contenant toutes les routes liées à l'authentification
 */
export const AuthRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Routes d'authentification */}
      <Route path={AUTH_ROUTES.LOGIN} element={<LoginPage />} />
      <Route path={AUTH_ROUTES.REGISTER} element={<RegisterPage />} />
      
      {/* Redirections par défaut */}
      <Route path="*" element={<Navigate to={AUTH_ROUTES.LOGIN} replace />} />
    </Routes>
  );
};

/**
 * HOC pour protéger une route
 */
export const withProtection = (Component: React.ComponentType, roles?: UserRole[]) => {
  return () => (
    <ProtectedRoute requiredRoles={roles}>
      <Component />
    </ProtectedRoute>
  );
};

export default AuthModule;
